import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchNotifications } from '@/api/notifications';
import type { UseNotificationsOptions } from '@/components/shared/NotificationsSheet/types';

export function useNotifications({
  tab,
  subTab,
  resourceType,
  companySearch,
  enabled,
}: UseNotificationsOptions) {
  return useInfiniteQuery({
    queryKey: ['notifications', tab, subTab, resourceType, companySearch],
    queryFn: ({ pageParam }) =>
      fetchNotifications({
        tab,
        ...(subTab !== undefined ? { subTab } : {}),
        page: pageParam as number,
        ...(resourceType !== undefined ? { resourceType } : {}),
        ...(companySearch !== undefined ? { companySearch } : {}),
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce((n, p) => n + p.data.length, 0);
      return loaded < lastPage.metadata.pagination.total
        ? allPages.length
        : undefined;
    },
    enabled,
    staleTime: 30_000,
  });
}
